/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddClientTeamMemberRequest
 */
export interface AddClientTeamMemberRequest {
    /**
     * Email address of the new team member.
     */
    email?: string;
    /**
     * First name of the new team member.
     */
    firstname?: string;
    /**
     * Last name of the new team member.
     */
    lastname?: string;
}

/**
 * Check if a given object implements the AddClientTeamMemberRequest interface.
 */
export function instanceOfAddClientTeamMemberRequest(value: object): value is AddClientTeamMemberRequest {
    return true;
}

export function AddClientTeamMemberRequestFromJSON(json: any): AddClientTeamMemberRequest {
    return AddClientTeamMemberRequestFromJSONTyped(json, false);
}

export function AddClientTeamMemberRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddClientTeamMemberRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'] == null ? undefined : json['email'],
        'firstname': json['firstname'] == null ? undefined : json['firstname'],
        'lastname': json['lastname'] == null ? undefined : json['lastname'],
    };
}

export function AddClientTeamMemberRequestToJSON(json: any): AddClientTeamMemberRequest {
    return AddClientTeamMemberRequestToJSONTyped(json, false);
}

export function AddClientTeamMemberRequestToJSONTyped(value?: AddClientTeamMemberRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'email': value['email'],
        'firstname': value['firstname'],
        'lastname': value['lastname'],
    };
}

